import { manufacturingFetch } from "@/lib/manufacturingClient";

export type PackedAuditSession = {
  id: string;
  plant_id: string;
  status: "open" | "closed";
  open_build_need: Record<string, number>;
  opened_at: string;
};

export type PackedAuditLine = {
  id: string;
  material_id: string;
  material_code: string;
  material_name: string;
  material_unit: string;
  book_on_hand_qty: number;
  packed_qty: number;
  bay_qty: number;
  open_build_need_qty: number;
  audited_on_hand_qty: number;
  delta_qty: number;
  unit_cost: number;
  reversed_at: string | null;
  returned_qty: number;
};

export type PackedAuditPayload = {
  ok: true;
  session: PackedAuditSession | null;
  lines: PackedAuditLine[];
  need_warning: string | null;
};

export function getPackedAuditSession(plant_id: string) {
  return manufacturingFetch<PackedAuditPayload>("/api/mfg/packed-audit/session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ plant_id }),
  });
}

export function openPackedAuditSession(plant_id: string) {
  return manufacturingFetch<PackedAuditPayload>("/api/mfg/packed-audit/open", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ plant_id }),
  });
}

export function postPackedAuditLine(payload: {
  session_id: string;
  material_id: string;
  packed_qty: number;
  bay_qty: number;
}) {
  return manufacturingFetch<{ ok: true; line: PackedAuditLine }>("/api/mfg/packed-audit/lines", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function reversePackedAuditLine(line_id: string) {
  return manufacturingFetch<{ ok: true; line: PackedAuditLine }>("/api/mfg/packed-audit/lines/reverse", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ line_id }),
  });
}

export function closePackedAuditSession(session_id: string) {
  return manufacturingFetch<{ ok: true; session: PackedAuditSession }>("/api/mfg/packed-audit/close", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id }),
  });
}
